import React from "react";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";

const PlayPauseButton = ({
  shouldDisplayPlayPauseButton,
  playPauseIcon,
  translate,
  playPauseButtonHandler,
  playButtonRef,
  spinnerToggle,
}) => {
  const theme = useTheme();
  if (!shouldDisplayPlayPauseButton) {
    return null;
  }

  return (
    <VideoPlayerButtonComponent
      src={process.env.PUBLIC_URL + playPauseIcon}
      alt={playPauseIcon === "/images/playback-play.svg" ? translate("play") : translate("pause")}
      buttonClassName="playbackButton"
      onClickHandler={playPauseButtonHandler}
      ref={playButtonRef}
      disabled={spinnerToggle}
      tooltipDirection="top"
      $hoverBackgroundColor={theme.colours.mineShaftGray}
    />
  );
};

export default PlayPauseButton;
